// @ts-nocheck
import React, { useCallback, useState, useEffect } from "react";
import { useGetCmsSectionArticle } from "api/endpoints/useGetCmsSectionArticle";
import classnames from "classnames";
import { useSelector } from "store";

import styles from "./HeaderTopInfo.module.scss";

const HeaderTopInfo = () => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);
  const { token } = useSelector((state) => state.auth);

  // Pobieranie artykułu CMS z sekcji HEADER
  const { data: singleArticleData, refetch: refetchSingleData } =
    useGetCmsSectionArticle("HEADER", "HEADER_MESSAGE", {
      enabled: false,
    });

  useEffect(() => {
    refetchSingleData();
  }, [refetchSingleData, token]);

  const getBannerContent = useCallback(() => {
    if (!singleArticleData?.article_fields) return null;

    const komunikatField = singleArticleData.article_fields.find(
      (field) => field.type === "STRING"
    );

    return komunikatField?.value || null;
  }, [singleArticleData]);

  const bannerContent = getBannerContent();

  const handleClose = useCallback(() => {
    setIsBannerVisible(false);
  }, []);

  return (
    <>
      {isBannerVisible && bannerContent && (
        <div className={classnames(styles.banner, "StylePath-Components-Layouts-MainLayout-HeaderTopInfo")}>
          <div className={styles.content}>
            <span dangerouslySetInnerHTML={{ __html: bannerContent }} />
          </div>
          <button
            className={styles.closeButton}
            onClick={handleClose}
            aria-label="Zamknij banner"
            type="button"
          >
            ✕
          </button>
        </div>
      )}
    </>
  );
};

export default HeaderTopInfo;
